import React from "react";

const pagesToShow = (currentPage, pagination) => {
    if (pagination.length <= 10) {
        return pagination;
    } else if (currentPage < 6) {
        return pagination.slice(0, 10);
    } else if (currentPage > pagination.length - 5) {
        return pagination.slice(pagination.length - 10, pagination.length);
    } else {
        return pagination.slice(currentPage - 6, currentPage + 4);
    }
};

export default function Pagination(props) {
    let showFirst = props.currentPage !== 1;
    let showPrev = props.currentPage > 1;
    let showLast = props.currentPage !== props.pagination.length;
    let showNext = props.currentPage < props.pagination.length && props.currentPage !== props.pagination.length;

    return (
        <>
            {props.pagination.length > 1 && (
                <nav aria-label="">
                    <ul class="pagination">
                        <li
                            onClick={() => (showFirst ? props.handlePageChange(1) : null)}
                            class={"page-item " + (!showFirst && "disabled")}
                        >
                            <a class="page-link first-btn"></a>
                        </li>

                        <li
                            onClick={() => (showPrev ? props.handlePageChange(props.currentPage - 1) : null)}
                            class={"page-item " + (!showPrev && "disabled")}
                        >
                            <a class="page-link prev-btn"></a>
                        </li>

                        {pagesToShow(props.currentPage, props.pagination).map((number) => (
                            <li
                                onClick={() => props.handlePageChange(number)}
                                class={"page-item " + (number === props.currentPage ? " active" : "")}
                                key={number}
                            >
                                <a class="page-link">{number}</a>
                            </li>
                        ))}

                        <li
                            onClick={() => (showNext ? props.handlePageChange(props.currentPage + 1) : null)}
                            class={"page-item " + (!showNext && "disabled")}
                        >
                            <a class="page-link next-btn"></a>
                        </li>

                        <li
                            onClick={() => (showLast ? props.handlePageChange(props.pagination.length) : null)}
                            class={"page-item " + (!showLast && "disabled")}
                        >
                            <a class="page-link last-btn"></a>
                        </li>
                    </ul>
                </nav>
            )}
        </>
    );
}
